import { call, put, takeLatest } from 'redux-saga/effects'
import { USER_LOGIN_REQUEST } from './constants';
import { loginUserSuccess, loginUserFailure } from "./actions";
import remote from '../../../../services/remote'
import SentryManager from "../../../../monitoring/Sentry";

function* loginUser (action) {
    try {
        const response = yield call(remote, {
            route: '/entrance/login',
            method: 'put',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(loginUserSuccess(response.data));
        } else {
            yield put(loginUserFailure(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

export default function* watchLoginUserSaga() {
    yield takeLatest(USER_LOGIN_REQUEST , loginUser);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Signin/saga.js